import { render, staticRenderFns } from "./SellinTabelaDetalhado.vue?vue&type=template&id=1e548a68&lang=html&"
import script from "./SellinTabelaDetalhado.vue?vue&type=script&lang=js&"
export * from "./SellinTabelaDetalhado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/sell-in/SellinTabelaDetalhado.vue
// module id = 1478
// module chunks = 28